import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

type CopyTemplateModalProps = {
	readonly onClose: () => void;
	readonly onConfirm: () => void;
	readonly templateName: string;
};

export function CopyTemplateModal({
	onClose,
	onConfirm,
	templateName,
}: CopyTemplateModalProps) {
	return (
		<TraxModal
			cancelText={"Cancel"}
			confirmText={"Copy"}
			onCancel={onClose}
			onClose={onClose}
			onConfirm={onConfirm}
			title={"Copy Template"}
			type={"confirmation"}
		>
			<p>
				Are you sure you want to copy the template{" "}
				<strong>{templateName}</strong>?
			</p>
		</TraxModal>
	);
}
